import type { SVGProps, ReactElement } from 'react'

/** Icono de usuario del header — canvas 40×40, mismo peso visual que Help/Wishlist/Cart. */
const User = (props: SVGProps<SVGSVGElement>): ReactElement => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <g transform="translate(11.886 9.500) scale(0.95455)">
                <path
                    d="M14.5402 13.1828C13.8991 12.2836 13.0295 11.54 12.0459 11.0127C11.5453 10.7446 11.0183 10.5372 10.465 10.4075C10.1049 10.321 12.687 10.1135 13.618 6.87998C14.8213 2.6695 10.4826 -1.38537 6.29326 0.456177C4.25568 1.34669 2.84167 3.47355 2.89437 5.66094C2.9295 7.21717 3.62332 9.17976 6.15273 10.1135C3.71994 10.468 2.27958 11.8427 1.3047 13.8485C-0.0829563 16.7016 -0.0478256 20.4019 0.0312183 20.5057C0.101479 20.6008 9.49892 24.0504 16.3933 20.1339C16.7359 19.9437 16.3582 15.7247 14.5402 13.1828Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

export default User
